import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ModalHeader(_ref) {
  var {
    className,
    children,
    closeButton = true,
    style,
    toggle,
    'data-testid': dataTestId
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "modal-header ".concat(className),
    style: style,
    children: [/*#__PURE__*/_jsx("h5", {
      className: "modal-title",
      children: children
    }), closeButton && /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "close",
      "data-dismiss": "modal",
      "aria-label": "Close",
      onClick: toggle,
      children: /*#__PURE__*/_jsx("span", {
        "aria-hidden": "true",
        children: "\xD7"
      })
    })]
  });
}
export default ModalHeader;
//# sourceMappingURL=ModalHeader.js.map